var _style, _path, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldbet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137 24",
    style: {
      enableBackground: "new 0 0 137 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFCB03;}\n\t.st1{clip-path:url(#SVGID_00000044897607359552011070000015293178853480965290_);}\n\t.st2{fill:#0a1b4e;}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,0.4h17.2c1.6,0,2.9,1.3,2.9,2.9v17.2c0,1.6-1.3,2.9-2.9,2.9H3.2c-1.6,0-2.9-1.3-2.9-2.9V3.2 C0.3,1.7,1.6,0.4,3.2,0.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 4,
    y: 4.1,
    width: 15.6,
    height: 15.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080927554958509025940000012983984760193254332_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080927554958509025940000012983984760193254332_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.5,16.4c-0.2,1.1-0.9,1.9-1.9,2.5c-1,0.5-2.2,0.7-3.3,0.8c-1,0-2,0-3,0c1.4-0.4,2.6-1.1,3.8-1.9v-7.2 H6.5l1.2,3.3h3.2v1.8c-0.8,0.5-1.7,0.6-2.5,0.6c-0.7,0-1.4-0.2-2.1-0.5c-2.4-1.2-2.9-4.5-1.3-6.6c0.8-1,2-1.6,3.3-1.5 c0.8,0,1.5,0.2,2.2,0.5c0.5,0.3,1,0.6,1.5,1L14.7,6c-0.4-0.3-0.8-0.7-1.3-0.9c-0.6-0.4-1.3-0.7-2.1-0.9h1.2 c1.2,0,2.4,0,3.5,0.4c0.7,0.2,1.3,0.6,1.8,1.2c0.5,0.6,0.8,1.5,0.8,2.3c0,1.1-0.4,2.1-1.3,2.8c-0.5,0.4-1,0.6-1.5,0.9 c1.1,0.4,2.2,0.8,3,1.7C19.6,14,19.7,15.3,19.5,16.4z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.4,11V6.2h-4V2h-5.8v4.3h-2.1v3.9c-1.2-2.6-3.6-4.3-7.4-4.3c-4.5,0-7.7,3.1-8.4,7.3 c-0.7-0.7-1.7-1.2-2.9-1.7c1.9-0.9,3.3-2.2,3.3-4.8c0-1.5-0.5-2.7-1.4-3.6c-1.2-1.2-3.1-1.9-5.8-1.9H90.7v21.5h11.2 c4.1,0,6.9-1.4,7.7-3.8c1.5,2.6,4.3,4.3,7.9,4.3c3.3,0,5.7-1.4,7.2-3.4l-3.1-2.7c-1.2,1.2-2.2,1.7-3.8,1.7c-1.9,0-3.1-0.9-3.6-2.7 h11.2v-1.2c0-1.4-0.2-2.7-0.7-4.1h1.7v6.8c0,3.9,2.1,5.5,5.7,5.5c1.5,0,3.1-0.3,4.1-1v-4.6c-0.7,0.3-1.4,0.5-2.2,0.5 c-1,0-1.5-0.5-1.5-1.7v-5.6C132.5,11,136.4,11,136.4,11z M96.7,6.1h4c1.7,0,2.8,0.7,2.8,1.9c0,1.4-1,1.9-2.9,1.9h-3.8V6.1z  M101.4,18h-4.6v-3.9h4.6c2.1,0,2.9,0.9,2.9,1.9C104.3,17.3,103.1,18,101.4,18z M114.3,13.2c0.3-1.9,1.4-3.1,2.9-3.1 c1.5,0,2.8,1.2,2.9,3.1H114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.3,1.2v6.9c-1.2-1.2-2.6-2.4-5.1-2.4c-2.9,0-5.6,1.9-6.8,5.1V1.2h-5.6v9.9c-1.4-3.3-4.4-5.5-8.6-5.5 c-3.8,0-6.8,2.1-8.4,5v-0.5H38.3l1.5,4.5h4.3v2.6C43.2,17.7,42,18,40.7,18c-3.4,0-5.8-2.6-5.8-6c0-3.4,2.4-6,5.5-6 c2.1,0,3.6,0.7,5.1,2.1l3.4-4.3c-1.5-1.2-3.1-2.2-5.1-2.7c-1-0.3-2.2-0.3-3.6-0.3c-1.2,0-2.2,0.2-3.2,0.3c-5,1.4-8.4,5.7-8.4,10.8 c0,6.5,5,11.1,11.8,11.1c3.9,0,7-1.4,9.4-3.3v-1.5c1.4,2.9,4.4,4.8,8.2,4.8c4.1,0,7.4-2.2,8.6-5.5v5.1h5.8v-4.8 c1.2,3.3,3.8,5.1,6.8,5.1c2.6,0,3.9-1.2,5.1-2.6v2.2h5.8V1.2H84.3z M58.1,18.4c-2.1,0-3.6-1.7-3.6-3.8c0-2.1,1.4-3.8,3.4-3.8 c2.1,0,3.6,1.7,3.6,3.8C61.5,16.7,60.2,18.4,58.1,18.4z M81,18.4c-1.9,0-3.4-1.5-3.4-3.8c0-2.2,1.5-3.8,3.4-3.8 c1.9,0,3.4,1.5,3.4,3.8C84.5,16.8,82.9,18.4,81,18.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldbet);
export default __webpack_public_path__ + "static/media/goldbet.4269f789282f246b3a845f1014fd4b93.svg";
export { ForwardRef as ReactComponent };